import { useTranslation } from 'react-i18next';

import styles from './placeholder.module.scss';

export const Placeholder: React.FC = () => {
  const { t } = useTranslation();

  return <div className={styles.widgetPlaceholder}>{t('UI:WidgetManager.widgetPlaceholder.label')}</div>;
};
